
import { resolveContactGreeting } from '../config/contactGreetingDefaults';

export function buildWhatsAppUrl(phone: string, profileType: string, contactGreeting?: string | null): string {
  const message = resolveContactGreeting(profileType, contactGreeting);
  const cleaned = phone.replace(/D/g, '');
  return 'https://wa.me/' + cleaned + '?text=' + encodeURIComponent(message);
}

export function buildEmailUrl(email: string, profileType: string, contactGreeting?: string | null): string {
  const body = resolveContactGreeting(profileType, contactGreeting);
  const subject = encodeURIComponent('Enquiry from CommonQR');
  return 'mailto:' + email + '?subject=' + subject + '&body=' + encodeURIComponent(body);
}

export function buildTelegramUrl(username: string, profileType: string, contactGreeting?: string | null): string {
  const message = resolveContactGreeting(profileType, contactGreeting);
  const cleaned = username.replace(/@/g, '');
  return 'https://t.me/' + cleaned + '?text=' + encodeURIComponent(message);
}

export function buildCallUrl(phone: string): string {
  return 'tel:' + phone.replace(/s/g, '');
}

export function buildSmsUrl(phone: string, profileType: string, contactGreeting?: string | null): string {
  const message = resolveContactGreeting(profileType, contactGreeting);
  return 'sms:' + phone.replace(/s/g, '') + '?body=' + encodeURIComponent(message);
}
